import * as routes from '../constants/routes'

const initialState = {
    items: [{
        id: 'intro',
        name: 'Introduction',
        link: routes.INSTRUCTIONS_INTRO,
    }, {
        id: 'descrip',
        name: 'Description',
        link: routes.INSTRUCTIONS_DESCRIP,
    }, {
        id: 'usage',
        name: 'Usage',
        link: routes.INSTRUCTIONS_USAGE,
    }, {
        id: 'usage/framework_selection',
        name: 'Select Theme',
        link: routes.INSTRUCTIONS_USAGE_FRAMEWORKS,
    }, {
        id: 'usage/analyze',
        name: 'Analyze Theme',
        link: routes.INSTRUCTIONS_USAGE_ANALYZE,
    }, {
        id: 'brushing',
        name: 'Brushing and Linking',
        link: routes.INSTRUCTIONS_BRUSHING,
    }, {
        id: 'settings',
        name: 'Settings',
        link: routes.INSTRUCTIONS_SETTINGS,
    }, {
        id: 'map',
        name: 'Map Toolbar',
        link: routes.INSTRUCTIONS_MAP,
    }, {
        id: 'references',
        name: 'References',
        link: routes.INSTRUCTIONS_REFERENCES,
    }],
}

export default function tableOfContents(state = initialState, action) {
    switch (action.type) {
    default:
        return state
    }
}
